import React from 'react'
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// Pass the tooltip text in "title" prop

const TooltipWrapper = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: "12px",
      fontFamily: "Montserrat"
    },
  }));

export default TooltipWrapper

// exaple

{/* <BootstrapTooltip title="Add this to tooltip">   
   <Button>TEXT</Button>
</BootstrapTooltip> */}